<template>
  <v-container fluid>
    <!-- Sidebar -->
    <SidebarNavigation />
    <v-card>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>

    <v-card>
      <v-tabs-items v-model="tab">
        <!-- tab 1 -->
        <v-tab-item>
          <v-row class="mb-4">
            <v-col xs="12" sm="12" md="4" lg="3" class="mt-4 custom-border">
              <v-card-subtitle class="text-center">
                <v-icon color="green">mdi-wallet</v-icon>
                <span class="text-h6 font-weight-bold green--text">
                  {{ saldo_point.toLocaleString() }} Point
                </span>
              </v-card-subtitle>

              <v-divider class="my-4"></v-divider>

              <v-form v-model="isValid" class="mb-4" @submit.prevent>
                <v-text-field
                  v-model="formatted"
                  label="Jumlah Poin"
                  type="text"
                  class="mt-2"
                  outlined
                  dense
                  :rules="[
                    (v) => !!v || 'Jumlah poin tidak boleh kosong!',
                    (v) => v > 0 || 'Minimal 1 poin',
                    (v) =>
                      /^[0-9]+$/.test(v.replace(/\./g, '')) ||
                      'Hanya boleh angka!',
                    (v) =>
                      parseInt(v.replace(/\./g, ''), 10) > 0 ||
                      'Jumlah poin harus lebih dari 0!',
                    (v) =>
                      parseInt(v.replace(/\./g, ''), 10) <= saldo_point ||
                      'Point tidak mencukupi!',
                  ]"
                />

                <v-alert
                  v-if="exchangePoints.toLocaleString()"
                  type="warning"
                  dense
                  class="text-center soft-alert"
                >
                  Anda akan mendapatkan
                  <strong class="green--text"
                    >Rp{{ convertedAmount.toLocaleString() }}</strong
                  >
                </v-alert>

                <v-btn
                  :disabled="true"
                  color="blue-lighten-2"
                  block
                  class="mt-3 soft-button"
                  @click="confirmExchange"
                >
                  <v-icon left>mdi-swap-horizontal</v-icon>
                  Tukarkan Poin
                </v-btn>

                <!-- <v-btn
                  :disabled="!isValid"
                  color="blue-lighten-2"
                  block
                  class="mt-3 soft-button"
                  @click="confirmExchange"
                >
                  <v-icon left>mdi-swap-horizontal</v-icon>
                  Tukarkan Poin
                </v-btn> -->
              </v-form>
            </v-col>

            <v-col xs="12" sm="12" md="7" lg="8" class="mt-4 custom-border">
              <v-row class="pt-3 pl-1 pa-1">
                <!-- <v-col cols="12" md="3" class="pa-1">
                  <v-menu
                    v-model="pagination.startMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        readonly
                        v-model="pagination.startDate"
                        label="Tanggal Awal"
                        v-bind="attrs"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pagination.startDate"
                      @input="onDateChange('start')"
                      locale="id"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="3" class="pa-1">
                  <v-menu
                    v-model="pagination.endMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="pagination.endDate"
                        label="Tanggal Akhir"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pagination.endDate"
                      @input="onDateChange"
                      locale="id"
                    ></v-date-picker>
                  </v-menu>
                </v-col> -->

                <!-- <v-col cols="12" md="3" class="pa-1">
                  <v-text-field
                    v-model="pagination.search"
                    label="Search"
                    append-icon="mdi-magnify"
                    dense
                    hide-details
                    class="search-input"
                    outlined
                    @input="debouncedSearch"
                  ></v-text-field>
                </v-col> -->
              </v-row>

              <v-row>
                <v-col>
                  <v-data-table
                    mobile-breakpoint="0"
                    fixed-header
                    dense
                    class="elevation-5"
                    :headers="tableHeaders"
                    :items="pointRedeemList"
                    :items-per-page.sync="pagination.itemsPerPage"
                    :page.sync="pagination.page"
                    :sort-by="pagination.sortBy"
                    :sort-desc="pagination.sortDesc"
                    :loading="isLoading"
                    :server-items-length="totalPointRedeem"
                    item-key="id"
                    @update:page="updateQuery('page', $event)"
                    @update:items-per-page="updateQuery('itemsPerPage', $event)"
                    @update:sort-by="updateQuery('sortBy', $event)"
                    @update:sort-desc="updateQuery('sortDesc', $event)"
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <td>
                            <div
                              v-if="item.type === 'earn'"
                              style="color: darkcyan"
                            >
                              {{ item.points.toLocaleString() }}
                              <small>{{ ` - (${item.noted_earn})` }}</small>
                            </div>
                            <div v-else style="color: red">
                              {{ item.points.toLocaleString() }}
                            </div>
                          </td>
                          <td>
                            Rp {{ parseInt(item.amount).toLocaleString() }}
                          </td>
                          <!-- <td>
                            <v-tooltip>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  @click="openDialogToken(item)"
                                >
                                  <v-icon color="primary">mdi-eye</v-icon>
                                </v-btn>
                              </template>
                              Lihat Token
                            </v-tooltip>
                          </td> -->
                          <td>{{ item.status }}</td>

                          <td>
                            {{ item.created_on }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Dialog Konfirmasi -->
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          Konfirmasi Penukaran
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-center my-4">
          Anda yakin ingin menukar
          <strong class="blue--text">{{
            exchangePoints.toLocaleString()
          }}</strong>
          poin dengan jumlah uang
          <strong class="green--text"
            >Rp{{ convertedAmount.toLocaleString() }}</strong
          >?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialog = false">Batal</v-btn>
          <v-btn color="primary" @click="submit">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog point token -->
    <v-dialog v-model="dialogPointToken" max-width="600px">
      <v-card>
        <v-card-title class="headline text-center">
          🔐 Kode Token Anda
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <p>Berikut adalah kode token Anda:</p>
            <div class="token-box">
              {{ pointToken }}
            </div>
            <v-btn color="secondary" small @click="copyToken">
              📋 Salin Token
            </v-btn>
            <p>
              Berikan kode token ini ke tim improvement untuk menukarkan dengan
              uang tunai.
            </p>
            <!-- <p>
              Token ini berlaku dalam waktu 24 Jam sampai
              <strong>{{ pointTokenExpires }}</strong
              >.
            </p> -->
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="dialogPointToken = false">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import { getLast30Days } from "@/utils/date";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      tableHeaders: [
        { text: "Point", align: "center", value: "point" },
        { text: "Amount", align: "center", value: "amount" },
        { text: "Status", align: "center", value: "status" },
        { text: "Dibuat", align: "center", value: "id" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        startDate: getLast30Days().start,
        endDate: getLast30Days().end,
        search: "",
      },
      pointRedeemList: [],
      pointToken: "",
      pointTokenExpires: null,
      totalPointRedeem: 0,
      saldo_point: 0,
      exchangePoints: 0, // Jumlah poin yang ingin ditukar
      pointConvert: 0, // 1 poin = 100 rupiah
      dialog: false,
      dialogPointToken: false,
      isValid: false,
      tab: 0,
      tabItems: ["Input"],
      isLoading: false,
    };
  },
  methods: {
    async fetchSaldoPointByEmail() {
      api
        .get(`/points/saldo?email=${this.user.mst_employee_email}`)
        .then(({ data }) => {
          this.saldo_point = parseInt(data.data.saldo_point);
          // console.log(data.data.saldo_point);
        })
        .catch((error) => {
          console.error("Error fetching employee:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchConvert() {
      api
        .get(`/parameters/CONVERT`)
        .then(({ data }) => {
          // console.log(data.data[0].value);
          this.saldo_point_convert = parseInt(data.data[0].value);
          // console.log(data);
        })
        .catch((error) => {
          console.error("Error fetching convert:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchRedeemPoint() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      await api
        .get("/points/redeem", { params })
        .then(({ data }) => {
          // console.log(data);
          this.pointRedeemList = data.data.data;
          this.totalPointRedeem = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    confirmExchange() {
      this.dialog = true;
    },
    async copyToken() {
      try {
        await navigator.clipboard.writeText(this.pointToken);
        store.dispatch("triggerSnackbar", {
          message: "Token berhasil disalin! ✅",
          isSuccess: true,
        });
      } catch (err) {
        store.dispatch("triggerSnackbar", {
          message: "Gagal menyalin token ❌",
          isSuccess: false,
        });
      }
    },
    openDialogToken(params) {
      this.pointToken = params.point_token;
      this.pointTokenExpires = params.pointTokenExpires;
      this.dialogPointToken = true;
    },
    goToValidation(id, token) {
      this.$router.push({
        name: "validation",
        params: { id: id, token: token },
      });
    },
    submit() {
      store.dispatch("showLoading");
      const payload = {
        exchangePoints: this.exchangePoints,
        amount: this.convertedAmount,
      };
      api
        .post("/points/redeem", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchConvert();
          this.fetchSaldoPointByEmail();
          this.fetchRedeemPoint();
          this.exchangePoints = 0;
          this.dialog = false;
          this.pointToken = response.data.data.pointToken;
          this.pointTokenExpires = response.data.data.pointTokenExpires;
          // this.dialogPointToken = true;
          this.tab = 0;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
          this.goToValidation(
            response.data.data.id,
            response.data.data.pointToken
          );
        })
        .catch((error) => {
          let message = "Failed to save redeem point!";
          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  watch: {
    pagination: {
      handler: "fetchRedeemPoint",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  mounted() {
    store.commit("setTitle", "Penukaran");
    this.fetchSaldoPointByEmail();
    this.fetchConvert();
    this.fetchRedeemPoint();
    // console.log(this.user.mst_employee_id);
    this.updatePagination(this.$route.query);
  },
  computed: {
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
    formatted: {
      get() {
        return this.exchangePoints
          ? new Intl.NumberFormat("id-ID").format(this.exchangePoints)
          : "";
      },
      set(value) {
        // Hapus titik (separator ribuan) dan simpan angka asli
        let numericValue = parseInt(value.replace(/\D/g, ""), 10);
        this.exchangePoints = isNaN(numericValue) ? 0 : numericValue;
      },
    },
    convertedAmount() {
      console.log(this.saldo_point_convert);
      return this.exchangePoints
        ? this.exchangePoints * this.saldo_point_convert
        : 0;
    },
  },
};
</script>

<style scoped>
/* Background halaman */
.v-container {
  background-color: #f0f4f8; /* Biru pastel */
}

/* Card lebih soft */
.shadow-soft {
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  border-radius: 12px;
}

/* Tombol lebih soft */
.soft-button {
  border-radius: 8px;
  font-weight: bold;
  transition: background 0.3s ease;
}

.soft-button:hover {
  background-color: #42a5f5 !important; /* Warna biru lebih gelap saat hover */
}

/* Alert lebih nyaman */
.soft-alert {
  background-color: #fff9c4 !important; /* Kuning pastel */
  color: #5d4037 !important; /* Coklat soft */
  border-radius: 8px;
  font-weight: 500;
}

.v-data-table td:nth-child(1),
td:nth-child(2),
td:nth-child(3),
td:nth-child(4),
td:nth-child(5),
td:nth-child(6),
td:nth-child(7) {
  text-align: center;
}

.custom-border {
  border: 2px solid #e6e6e6; /* Border hitam */
  border-radius: 5px; /* Sudut melengkung */
  margin-right: 20px;
  margin-left: 20px;
  margin-top: 20px;
}
</style>
